/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { initialQueryState, KTSVG, useDebounce } from '../../../../../_dashboard/helpers';
import { useQueryRequest } from '../core/QueryRequestProvider';
import { useIntl } from 'react-intl';

const NewsletterListSearchComponent = () => {
  const { updateState } = useQueryRequest();
  const [searchTerm, setSearchTerm] = useState<string>('');
  const debouncedSearchTerm = useDebounce(searchTerm, 150);
  const intl = useIntl();

  useEffect(() => {
    if (debouncedSearchTerm !== undefined && searchTerm !== undefined) {
      updateState({ search: debouncedSearchTerm, ...initialQueryState });
    }
  }, [debouncedSearchTerm]);

  return (
    <div className='card-title'>
      <div className='d-flex align-items-center position-relative my-1'>
        <KTSVG
          path='/media/icons/duotune/general/gen021.svg'
          className='svg-icon-1 position-absolute ms-6'
        />
        <input
          type='text'
          className='form-control form-control-solid w-250px ps-14'
          placeholder={intl.formatMessage({ id: 'NEWSLETTER.SEARCH_PLACEHOLDER' })}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
    </div>
  );
};

export { NewsletterListSearchComponent };
